import type { SectionsFocusComponent } from '@twisto/api-cms'

import { useHighlightedText } from 'homepage/libs/hooks'

import { Button, StrapiMedia } from '../../atoms'

import * as styles from './focus.styles'

export function Focus({
  description,
  title,
  cta,
  src,
  highlightedTitleText,
}: SectionsFocusComponent) {
  const {
    before: titleBefore,
    highlight: titleHighlight,
    after: titleAfter,
  } = useHighlightedText(title, highlightedTitleText)

  return (
    <div css={styles.focus}>
      {title && (
        <h2 css={styles.title}>
          {titleBefore}
          <span>{titleHighlight}</span>
          {titleAfter}
        </h2>
      )}

      <div css={styles.description}>{description}</div>

      {cta && (
        <div>
          <Button {...cta[0]} variant="default" />
        </div>
      )}

      {src?.url && (
        <div css={styles.background}>
          <StrapiMedia {...src} />
        </div>
      )}
    </div>
  )
}
